/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { BaseAppEvent } from "./base";

type EventTypes = {
  onNavigationDrawerMenuClick: boolean;
};

class UiEvents extends BaseAppEvent<EventTypes> {
  onNavigationDrawerMenuClick(isFilterMenuShown: boolean) {
    this.emit("onNavigationDrawerMenuClick", isFilterMenuShown);
  }
}

export const uiEvents = new UiEvents();
